<template>
  <div id="js-chapter" class="chapter">
    <ul v-if="isChapter" class="chapter_list">
      <ChapterItem
        v-for="val, index in chapterList"
        :key="val + index"
        :title=" val.chapterTitle"
        :description="val.description"
        :seqNo="val.seqNo"
        :nowSeqNo="nowSeqNo"
        @changeChapter="changeChapter"
        />
    </ul>
    <div v-else class="notes_text">
      <p class="notes_text--detail" v-html="chapterList[0].description"></p>
    </div>
  </div>
</template>

<script>

import ChapterItem from '@/components/fanClub/notes/ChapterItem';

export default {
  components: {
    ChapterItem
  },
  props: {
    'isChapter': {
      type: Boolean,
      default: true
    },
    'chapterList': {
      type: Array,
      default: () => {}
    },
    'nowSeqNo': {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      isShowKeyword: false,
      isShowKeywordList: [],
    }
  },
  methods: {
    changeChapter(data) {
      this.$emit('changeChapter', data);
    },
  }
}
</script>

<style lang="css" scoped>
.chapter {
  /* max-height: 400px; */
  overflow-y: scroll;
}



.notes_text {
  color: #fff;
}
.notes_text--title {
  font-size: 14px;
}
.notes_text--detail {
  font-size: 12px;
  line-height: 1.8;
  margin-top: 24px;
}

.notes_text .text_right {
  font-size: 12px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/fanClub/notes/AudioChapter.vue